import { render, staticRenderFns } from "./ProfileSuspended.vue?vue&type=template&id=562037b9&scoped=true&"
import script from "./ProfileSuspended.vue?vue&type=script&lang=js&"
export * from "./ProfileSuspended.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSuspended.vue?vue&type=style&index=0&id=562037b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562037b9",
  null
  
)

export default component.exports